"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FormLabel = require("./FormLabel");
Object.keys(_FormLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormLabel[key];
    }
  });
});